export default __webpack_public_path__ + "static/media/LeaderBoard.7f9171ca.svg";